<template>
    <div><!-- 訂單變更查詢 -->
        <CCard>
            <CCardBody>
                <div class="d-flex justify-content-between">
                    <button v-if="!isEmployee" :disabled="disableConfirm" class="btn btn-success mb-2"  @click="changeOrderConfirmEvent">{{$t('Buttons.Confirm')}}</button>
                    <div v-if="isEmployee"> </div>
                    <div>
                        <button class="btn btn-edit mb-2 mr-2" @click="changeOrderPrintEvent">{{$t('Buttons.Print')}}</button>
                        <router-link class="btn btn-dark mb-2" @click.native="goBackEvent" to="">{{$t('Buttons.GoBack')}}</router-link>
                    </div>                    
                </div>
                <div class="info">
                    <div class="info_col">
                        <p>{{i18n('DocumentChangeQueryInfo.PurchasingDocument')}}: {{orderDetailRow.bsart + '-' + orderDetailRow.ebeln}}</p>
                        <p>{{i18n('DocumentChangeQueryInfo.VendorCode')}}: {{orderDetailRow.lifnr}}</p>
                        <p>{{i18n('DocumentChangeQueryInfo.GoodsDupplierCode')}}: {{orderDetailRow.gsLifnr}}</p>
                    </div>
                    <div class="info_col">
                        <p class="text-danger">{{i18n('DocumentChangeQueryInfo.DocumentVersion')}}: {{orderDetailRow.zzebver}}</p>
                        <p>{{i18n('DocumentChangeQueryInfo.Vendor')}}: {{orderDetailRow.customerName}}</p>
                        <p>{{i18n('DocumentChangeQueryInfo.GoodsSupplier')}}: {{orderDetailRow.gsLifnrName1}}</p>
                    </div>
                    <div class="info_col">
                        <p>{{i18n('DocumentChangeQueryInfo.DocumentDate')}}: {{fixDate(orderDetailRow.aedat)}}</p>
                        <p>{{i18n('DocumentChangeQueryInfo.DocumentStatus')}}: {{fixConfirmTime(orderDetailRow.confirmTime)}}</p>
                        <p>{{i18n('DocumentChangeQueryInfo.VendorConfirmData')}}: {{fixDate(orderDetailRow.confirmTime)}}</p>
                    </div>            
                </div>      
                <!-- PO -->          
                <table class="table" v-if="isPOType">
                    <thead class="thead-light">
                        <tr>                            
                            <th class="align-top text-left">{{i18n('DocumentChangeQueryInfo.HeaderChangeItem')}}</th>
                            <th></th>
                            <th class="align-top">{{i18n('DocumentChangeQueryInfo.BeforeChange')}}</th>                            
                            <th class="align-top">{{i18n('DocumentChangeQueryInfo.AfterChange')}}</th>
                        </tr>
                    </thead>                    
                    <tbody>
                        <tr class="">
                            <td class="align-top text-right">
                                <span>{{i18n('DocumentChangeQueryInfo.GoodsSupplierCode')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.TermsOfPaymnt')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.Incoterms')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.ShippingMethod')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.HeaderText')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.ChangeReason')}}</span> <br>
                            </td>
                            <td></td>
                            <td class="align-top">
                                <span :class="diffCss(orderDetailRow.zzbgsnumName1,orderDetailRow.zzagsnumName1)">{{orderDetailRow.zzbgsnumName1}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbztermTxt,orderDetailRow.zzaztermTxt)">{{orderDetailRow.zzbztermTxt}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbinco1,orderDetailRow.zzainco1)">{{orderDetailRow.zzbinco1}}{{orderDetailRow.zzbinco2}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbexpvzTxt,orderDetailRow.zzaexpvzTxt)">{{orderDetailRow.zzbexpvzTxt}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbhtext,orderDetailRow.zzahtext)">{{orderDetailRow.zzbhtext}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzcfacto,orderDetailRow.zzcfact)">{{orderDetailRow.zzcfacto}}</span> <br>
                            </td>
                            <td class="align-top">
                                <span :class="diffCss(orderDetailRow.zzbgsnumName1,orderDetailRow.zzagsnumName1)">{{orderDetailRow.zzagsnumName1}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbztermTxt,orderDetailRow.zzaztermTxt)">{{orderDetailRow.zzaztermTxt}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbinco1,orderDetailRow.zzainco1)">{{orderDetailRow.zzainco1}}{{orderDetailRow.zzainco2}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbexpvzTxt,orderDetailRow.zzaexpvzTxt)">{{orderDetailRow.zzaexpvzTxt}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbhtext,orderDetailRow.zzahtext)">{{orderDetailRow.zzahtext}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzcfacto,orderDetailRow.zzcfact)">{{orderDetailRow.zzcfact}}</span> <br>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="table" v-if="isPOType">
                    <thead class="thead-light">
                        <tr>
                            <th class="align-top text-left">{{i18n('DocumentChangeQueryInfo.ChangeItem')}}</th>
                            <th></th>
                            <th class="align-top">{{i18n('DocumentChangeQueryInfo.BeforeChange')}}</th>                            
                            <th class="align-top">{{i18n('DocumentChangeQueryInfo.AfterChange')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="dashed" v-for="(item ,index) in orderDetailRow.tbSupPocDtlList" :key="'tbSupPocDtlList_'+ index" >
                            <td class="align-top text-right">
                                <span>{{i18n('DocumentChangeQueryInfo.No')}}:{{fixNumber(item.ebelp)}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.MaterialVersion')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.ProductDrawingNumber')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.POQuantity')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.NetPrice')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.DeliveryData')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.ItemText')}}</span> <br>
                                <div class="text-left">
                                </div>
                            </td>
                            <td></td>
                            <td class="align-top">
                                <span></span> <br>
                                <span :class="diffCss(item.revlvo,item.revlv)">{{item.revlvo}}</span> <br>
                                <span :class="diffCss(item.zeinro,item.zeinr)">{{item.zeinro}}</span> <br>
                                <span :class="diffCss(item.mengeo,item.menge)">{{item.mengeo | currencyF3}}</span> <br>
                                <span :class="diffCss(item.netpro,item.netpr)">{{item.netpro | currencyF5}}</span> <br>
                                <span :class="diffCss(fixDate(item.eindto),fixDate(item.eindt))">{{fixDate(item.eindto)}}</span> <br>
                                <span :class="diffCss(item.zzremarko,item.zzremark)">{{item.zzremarko}}</span> <br>
                            </td>
                            <td class="align-top">
                                <span></span> <br>
                                <span :class="diffCss(item.revlvo,item.revlv)">{{item.revlv}}</span> <br>
                                <span :class="diffCss(item.zeinro,item.zeinr)">{{item.zeinr}}</span> <br>
                                <span :class="diffCss(item.mengeo,item.menge)">{{item.menge | currencyF3}}</span> <br>
                                <span :class="diffCss(item.netpro,item.netpr)">{{item.netpr | currencyF5}}</span> <br>                                
                                <span :class="diffCss(fixDate(item.eindto),fixDate(item.eindt))">{{fixDate(item.eindt)}}</span> <br>
                                <span :class="diffCss(item.zzremarko,item.zzremark)">{{item.zzremark}}</span> <br>
                            </td>
                         </tr>                       
                    </tbody>
                </table>
                <!-- SAG -->
                <table class="table"  v-if="!isPOType">
                    <thead class="thead-light">
                        <tr>                           
                            <th class="align-top text-left">{{i18n('DocumentChangeQueryInfo.HeaderChangeItem')}}</th>
                            <th></th>
                            <th class="align-top">{{i18n('DocumentChangeQueryInfo.BeforeChange')}}</th>                            
                            <th class="align-top">{{i18n('DocumentChangeQueryInfo.AfterChange')}}</th>
                        </tr>
                    </thead>                    
                    <tbody>
                        <tr class="">
                            <td class="align-top text-right">
                                <span>{{i18n('DocumentChangeQueryInfo.GoodsSupplierCode')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.TermsOfPaymnt')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.Incoterms')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.ShippingMethod')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.HeaderText')}}</span> <br>
                                <span>SAG生效日期</span> <br>
                                <span>SAG有效期結束</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.ChangeReason')}}</span> <br>
                            </td>
                            <td></td>
                            <td class="align-top">
                                <span :class="diffCss(orderDetailRow.zzbgsnumName1,orderDetailRow.zzagsnumName1)">{{orderDetailRow.zzbgsnumName1}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbztermTxt,orderDetailRow.zzaztermTxt)">{{orderDetailRow.zzbztermTxt}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbinco1,orderDetailRow.zzainco1)">{{orderDetailRow.zzbinco1}}{{orderDetailRow.zzbinco2}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbexpvzTxt,orderDetailRow.zzaexpvzTxt)">{{orderDetailRow.zzbexpvzTxt}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbhtext,orderDetailRow.zzahtext)">{{orderDetailRow.zzbhtext}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbkdatb,orderDetailRow.zzakdatb)">{{fixDate(orderDetailRow.zzbkdatb)}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbkdate,orderDetailRow.zzakdate)">{{fixDate(orderDetailRow.zzbkdate)}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzcfacto,orderDetailRow.zzcfact)">{{orderDetailRow.zzcfacto}}</span> <br>
                            </td>
                            <td class="align-top">
                                <span :class="diffCss(orderDetailRow.zzbgsnumName1,orderDetailRow.zzagsnumName1)">{{orderDetailRow.zzagsnumName1}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbztermTxt,orderDetailRow.zzaztermTxt)">{{orderDetailRow.zzaztermTxt}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbinco1,orderDetailRow.zzainco1)">{{orderDetailRow.zzainco1}}{{orderDetailRow.zzainco2}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbexpvzTxt,orderDetailRow.zzaexpvzTxt)">{{orderDetailRow.zzaexpvzTxt}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbhtext,orderDetailRow.zzahtext)">{{orderDetailRow.zzahtext}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbkdatb,orderDetailRow.zzakdatb)">{{fixDate(orderDetailRow.zzakdatb)}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzbkdate,orderDetailRow.zzakdate)">{{fixDate(orderDetailRow.zzakdate)}}</span> <br>
                                <span :class="diffCss(orderDetailRow.zzcfacto,orderDetailRow.zzcfact)">{{orderDetailRow.zzcfact}}</span> <br>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="table"  v-if="!isPOType">
                    <thead class="thead-light">
                        <tr>                            
                            <th class="align-top text-left">{{i18n('DocumentChangeQueryInfo.ChangeItem')}}單身變更項目</th>
                            <th></th>
                            <th class="align-top">{{i18n('DocumentChangeQueryInfo.BeforeChange')}}變更前</th>                            
                            <th class="align-top">{{i18n('DocumentChangeQueryInfo.AfterChange')}}變更後</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="dashed" v-for="(item ,index) in orderDetailRow.tbSupPocDtlList" :key="'SAGtbSupPocDtlList_'+ index">
                            <td class="align-top text-right">
                                <span>{{i18n('DocumentChangeQueryInfo.No')}}:{{fixNumber(item.ebelp)}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.MaterialVersion')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.ProductDrawingNumber')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.POQuantity')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.NetPrice')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.DeliveryData')}}</span> <br>
                                <span>{{i18n('DocumentChangeQueryInfo.ItemText')}}</span> <br>
                                <div class="text-left">                                   
                                </div>
                            </td>
                            <td></td>
                            <td class="align-top">
                                <span></span> <br>
                                <span :class="diffCss(item.revlvo,item.revlv)">{{item.revlvo}}</span> <br>
                                <span :class="diffCss(item.zeinro,item.zeinr)">{{item.zeinro}}</span> <br>
                                <span :class="diffCss(item.mengeo,item.menge)">{{item.mengeo | currencyF3}}</span> <br>
                                <span :class="diffCss(item.netpro,item.netpr)">{{item.netpro | currencyF5}}</span> <br>                                
                                <span :class="diffCss(fixDate(item.eindto),fixDate(item.eindt))">{{fixDate(item.eindto)}}</span> <br>
                                <span :class="diffCss(item.zzremarko,item.zzremark)">{{item.zzremarko}}</span> <br>
                            </td>
                            <td class="align-top">
                                <span></span> <br>
                                <span :class="diffCss(item.revlvo,item.revlv)">{{item.revlv}}</span> <br>
                                <span :class="diffCss(item.zeinro,item.zeinr)">{{item.zeinr}}</span> <br>
                                <span :class="diffCss(item.mengeo,item.menge)">{{item.menge | currencyF3}}</span> <br>
                                <span :class="diffCss(item.netpro,item.netpr)">{{item.netpr | currencyF5}}</span> <br>                                
                                <span :class="diffCss(fixDate(item.eindto),fixDate(item.eindt))">{{fixDate(item.eindt)}}</span> <br>
                                <span :class="diffCss(item.zzremarko,item.zzremark)">{{item.zzremark}}</span> <br>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
import { orderMixin } from '@/mixin/order'
export default {
    mixins: [orderMixin],
    data() {
        return {    
            proid : '',
            searchType: 'ChangeOrder'
        }
    },
    props : {
    },
    methods: {
        goBackEvent (){
            //判斷供應商且尚未按下確認功能
            if(!this.isEmployee && !this.disableConfirm){
                this.$confirm('若您尚未點選訂單上的[確認]鈕後，請點選[確認]再離開，謝謝！是否離開目前的網頁？', '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning'
                }).then(() => {
                    this.$router.push('changeorder');
                }).catch(() => {
                    //console.log("放棄了");
                });
                return;
            }
            this.$router.push('changeorder');
        },
        changeOrderConfirmEvent (){//訂單變更 -確認
            const url = `${this.$apiUrl_Order}/ChangeOrderConfirm`
            const param = {proid : this.proid};
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功          
                    this.orderDetailRow.confirmTime = new Date().yyyymmdd();
                    this.$alert('訂單變更確認完成','訊息',{});    
                }                    
            });
        },
        changeOrderPrintEvent (){ //訂單列印
            let url = `${this.$apiUrl_Print}/PrintChangeOrderDetail/${this.proid}`;
            this.openNewTabByALink('changeOrderPrint',url);
        },
        diffCss (v1,v2){
            if(v1 && v2){
                if(v1 !== v2){
                    return 'text-danger';        
                }
            }
            return '';
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        isPOType (){
            const {orderDetailRow} = this;
            //L 為 SAG，F 為 PO
            if(orderDetailRow && orderDetailRow.bstyp === 'L'){
                return false;
            }
            return true;
        },
        isEmployee() {            
            return this.$store.state.isEmployee;            
        },
        disableConfirm (){
            if(this.orderDetailRow && this.orderDetailRow.confirmTime){
                return true;
            }
            return false;
        }
    },
    mounted() {
        let orderId = sessionStorage.getItem('orderId');      
        if(orderId) {
            this.proid = orderId;
            this.getOrderDetail(orderId);
        } else{
            this.$router.push('changeorder');
        }
    }
}
</script>
<style lang="scss" scoped>
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table tr:nth-child(even) {
    background-color: transparent;
}

.info {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    // border: 1px solid #ececec;
    border: 2px solid ;
    // border-bottom: 1px solid #ececec;
    padding-top: 1rem;
}
.info_col {
    display: flex;
    flex-direction: column;

    > p {
        margin-left: 1rem;
        margin-right: 1rem;
    }
}

.dashed {
    border-bottom: none;
    border-bottom: 2px dashed;
}

.reply {
    display: flex;
    flex-direction: column;
    border: none;
    
    .btn {
        margin-top: 4rem;
    }
}

.table .thead-light th {
    color: #000;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}

.text-danger {
    font-weight: bolder;
}

</style>
